var CDP = {

  AMOUNT_TIERS: [
    { threshold: 299900,  pct: 10, label: '10% OFF', at: 'at ₹2,999' },
    { threshold: 399900,  pct: 12, label: '12% OFF', at: 'at ₹3,999' },
    { threshold: 499900,  pct: 15, label: '15% OFF', at: 'at ₹4,999' }
  ],

  QTY_TIERS: [
    { qty: 2, pct: 17, label: '17% OFF', how: 'Buy 2 items' },
    { qty: 3, pct: 18, label: '18% OFF', how: 'Buy 3 items' },
    { qty: 4, pct: 20, label: '20% OFF', how: 'Buy 4 items' }
  ],

  GIFT_TIERS: [
{ threshold: 599900, name: "FREE Earrings", at: "at ₹5,999", shortLabel: "FREE Earrings" },
{ threshold: 999900, name: "FREE Potli", at: "at ₹9,999", shortLabel: "FREE Potli" },
{ threshold: 1499900, name: "FREE Earrings + Potli", at: "at ₹14,999", shortLabel: "FREE Earrings + Potli" }

  ],


  fmt: function(paise) {
    return '₹' + Math.ceil(paise / 100).toLocaleString('en-IN');
  },

  show: function(id) { var el = document.getElementById(id); if (el) el.style.display = 'block'; },
  hide: function(id) { var el = document.getElementById(id); if (el) el.style.display = 'none'; },
  text: function(id, val) { var el = document.getElementById(id); if (el) el.innerHTML = val; },

  render: function(cart) {
    var wrapper = document.getElementById('cart-discount-progress');
    if (!wrapper) return;
    if (cart.item_count === 0) { wrapper.style.display = 'none'; return; }
    wrapper.style.display = 'block';

var subtotal = cart.items.reduce(function(s, i) { return s + (i.original_price * i.quantity); }, 0);
var discountedSubtotal = cart.total_price;
var totalQty = cart.items.reduce(function(s, i) { return s + i.quantity; }, 0);

CDP.renderHeader(discountedSubtotal);
CDP.renderProgressBar(discountedSubtotal);
CDP.renderDiscountCol(subtotal, totalQty);
CDP.renderGiftCol(discountedSubtotal);



  },

  // ── HEADER SUBTITLE ──
  renderHeader: function(subtotal) {
    var tiers = CDP.GIFT_TIERS;
    var nextGift = tiers.find(function(t) { return subtotal < t.threshold; });
    var subtitle = document.getElementById('cdp-subtitle');
    if (!subtitle) return;
    if (!nextGift) {
      subtitle.innerHTML = 'You\'ve unlocked <strong>all FREE gifts!</strong> 🎉';
    } else {
      var rem = nextGift.threshold - subtotal;
      subtitle.innerHTML = 'You are <strong>' + CDP.fmt(rem) + '</strong> away from a <strong>' + nextGift.shortLabel + '!</strong>';
    }
  },

  // ── PROGRESS BAR (gift-based) ──
  renderProgressBar: function(subtotal) {
    var tiers = CDP.GIFT_TIERS;
    var bar   = document.getElementById('cdp-gift-bar');
    var curr  = document.getElementById('cdp-bar-current');
    var tgt   = document.getElementById('cdp-bar-target');
    if (!bar) return;

    var nextIdx = -1;
    for (var i = 0; i < tiers.length; i++) {
      if (subtotal < tiers[i].threshold) { nextIdx = i; break; }
    }

    var prevThreshold, targetThreshold, targetLabel;
    if (nextIdx === -1) {
      prevThreshold   = tiers[tiers.length - 2] ? tiers[tiers.length - 2].threshold : 0;
      targetThreshold = tiers[tiers.length - 1].threshold;
      targetLabel     = tiers[tiers.length - 1].shortLabel;
    } else {
      prevThreshold   = nextIdx > 0 ? tiers[nextIdx - 1].threshold : 0;
      targetThreshold = tiers[nextIdx].threshold;
      targetLabel     = tiers[nextIdx].shortLabel;
    }

    var range    = targetThreshold - prevThreshold;
    var progress = nextIdx === -1 ? 1 : Math.max(0, Math.min((subtotal - prevThreshold) / range, 1));

    bar.style.transition = 'none';
    bar.style.width = '0%';
    void bar.offsetWidth;
    bar.style.transition = 'width 0.6s ease';
    bar.style.width = (progress * 100).toFixed(1) + '%';

    if (curr) curr.innerHTML = '<strong>' + CDP.fmt(subtotal) + '</strong><br><span style="font-size:10px;color:#888;font-weight:400;">Current Cart Value</span>';
    if (tgt)  tgt.innerHTML  = '<strong>' + CDP.fmt(targetThreshold) + '</strong><br><span style="font-size:10px;color:#880e2f;font-weight:400;text-align:right;display:block;">To Get ' + targetLabel + '</span>';
  },

  // ── LEFT COL: AUTO DISCOUNT ──
  renderDiscountCol: function(subtotal, totalQty) {
    // Best applied
    var bestAmt = null;
    CDP.AMOUNT_TIERS.forEach(function(t) { if (subtotal >= t.threshold) bestAmt = t; });
    var bestQty = null;
    CDP.QTY_TIERS.forEach(function(t) { if (totalQty >= t.qty) bestQty = t; });

    var applied = null;
    if (bestAmt && bestQty) applied = bestAmt.pct >= bestQty.pct ? bestAmt : bestQty;
    else applied = bestAmt || bestQty;

    CDP.hide('cdp-disc-earned');
    CDP.hide('cdp-disc-next');
    CDP.hide('cdp-disc-maxed');

    if (applied) {
      CDP.show('cdp-disc-earned');
      CDP.text('cdp-disc-earned-pct', applied.label);
      CDP.text('cdp-disc-earned-at', applied.at || applied.how || '');
    }

     // Next better tier — amount tiers first, then qty tiers
    var appliedPct = applied ? applied.pct : 0;
    var nextAmt = CDP.AMOUNT_TIERS.find(function(t) { return subtotal < t.threshold && t.pct > appliedPct; });
    var nextQty = CDP.QTY_TIERS.find(function(t) { return totalQty < t.qty && t.pct > appliedPct; });

    var next = null;
    var nextHow = '';
    if (nextAmt) {
      // Still amount tiers remaining — show those first
      next = nextAmt;
      nextHow = 'Add ' + CDP.fmt(nextAmt.threshold - subtotal) + ' more';
    } else if (nextQty) {
      // All amount tiers exhausted — now show qty tiers
      next = nextQty;
      nextHow = 'Buy ' + nextQty.qty + ' items<br>to unlock';
    }

    if (next) {
      CDP.show('cdp-disc-next');
      CDP.text('cdp-disc-next-pct', next.label);
      CDP.text('cdp-disc-next-how', nextHow);
    } else if (!next && applied) {
      CDP.show('cdp-disc-maxed');
    }
  },

  // ── RIGHT COL: FREE GIFT ──
  renderGiftCol: function(subtotal) {
    var tiers = CDP.GIFT_TIERS;
    var lastApplied = null;
    tiers.forEach(function(t) { if (subtotal >= t.threshold) lastApplied = t; });
    var nextGift = tiers.find(function(t) { return subtotal < t.threshold; });

    CDP.hide('cdp-gift-earned');
    CDP.hide('cdp-gift-next');
    CDP.hide('cdp-gift-maxed');

    if (lastApplied) {
      CDP.show('cdp-gift-earned');
      CDP.text('cdp-gift-earned-name', lastApplied.name);
      CDP.text('cdp-gift-earned-at', lastApplied.at);
    }

    if (nextGift) {
      CDP.show('cdp-gift-next');
      CDP.text('cdp-gift-next-name', nextGift.name);
      CDP.text('cdp-gift-next-how', 'Add ' + CDP.fmt(nextGift.threshold - subtotal) + ' more to unlock');
    } else {
      CDP.show('cdp-gift-maxed');
    }
  },

  update: function() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { CDP.render(cart); });
  }
};

document.addEventListener('cart:updated', function() { setTimeout(CDP.update, 400); });
document.addEventListener('DOMContentLoaded', function() { setTimeout(CDP.update, 3000); });

if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe === 'function') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, function() { setTimeout(CDP.update, 400); });
}

setInterval(function() {
  var drawer  = document.querySelector('cart-drawer, #cart-drawer, .cart-drawer, .mini-cart, #mini-cart');
  var wrapper = document.getElementById('cart-discount-progress');
  if (drawer && getComputedStyle(drawer).display !== 'none' && wrapper && wrapper.style.display === 'none') {
    CDP.update();
  }
}, 2000);
